import React from 'react'

export const sortByValue = (type, field,  data) => {
    if (type === 'greaterThan') {
        return data.sort((a, b) => (a[field] > b[field]) ? 1 : -1)
    } else if (type === 'lessThan') {
        return data.sort((a, b) => (a[field] > b[field]) ? -1 : 1)
    }
};